import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
// import { faCircleInfo } from "@fortawesome/pro-light-svg-icons";

const IngredientIcon = ({ onClick, color = "#007bff" }) => {
  return (
    <div >
      <span>Ingredient component</span>
    {/* <FontAwesomeIcon
      icon={faCircleInfo}
      style={{
        color,
        fontSize:14
      }}
      onClick={
        // e.stopPropagation();
        onClick
      }
      /> */}
      </div>
  );
};

export default IngredientIcon;



// WEBPACK FOOTER //
// ./src/components/IngredientIcon.js